<div class="cropper-js-container">
  <img #image src="{{imageSrc}}" alt="">
  <div class="buttons">
    <button mat-button (click)="closeDialog()">{{ 'system.cancel' | translate }}</button>
    <button mat-button color="primary" (click)="getCroppedImage()">{{ 'system.save' | translate }}</button>
  </div>
</div>
